/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/PolarisGlobalViewsSettingsListPageQuery$parameters.ts';
import type { PolarisGlobalViewsSettingsListPageQuery } from './__generated__/PolarisGlobalViewsSettingsListPageQuery.graphql.ts';

type PolarisProductGlobalViewsSettingsListEntryPointComponent = EntryPointComponent<
	{
		globalViewsSettingsListQuery: PolarisGlobalViewsSettingsListPageQuery;
	},
	{},
	{},
	{}
>;

export const polarisProductGlobalViewsSettingsListEntryPoint: EntryPoint<
	PolarisProductGlobalViewsSettingsListEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<PolarisProductGlobalViewsSettingsListEntryPointComponent>(
		/* webpackChunkName: "async-polaris-settings-global-views-list", jiraSpaEntry: "async-polaris-ideas" */ './PolarisGlobalViewsSettingsListPage.tsx',
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => {
		return {
			queries: {
				globalViewsSettingsListQuery: {
					options: {
						// let's restore store-or-network with https://pi-dev-sandbox.atlassian.net/browse/POL-21943
						fetchPolicy: 'network-only' as const,
					},
					parameters,
					variables: {
						cloudId,
						filter: { containsText: '' },
						first: 50,
					},
				},
			},
		};
	},
});
